export const mapBackendLocaleToI18n = (locale: string | null): 'sv' | 'da' => {
  if (!locale) return 'sv';

  const normalized = locale.toLowerCase();

  if (normalized.startsWith('da')) return 'da';
  return 'sv';
};

export function parseAddress(fullAddress: string) {
  if (!fullAddress.includes(',')) {
    throw new Error(`Adressen måste innehålla ett kommatecken: "${fullAddress}"`);
  }

  const [streetRaw, zipCityRaw] = fullAddress
    .split(',')
    .map((part) => part.trim().replace(/\s+/g, ' '));

  const zipCityParts = zipCityRaw.split(' ');

  let zipCode = '';
  let city = '';

  if (zipCityParts.length >= 2) {
    if (/^\d{5}$/.test(zipCityParts[0])) {
      zipCode = zipCityParts[0];
      city = zipCityParts.slice(1).join(' ');
    } else if (/^\d{3}$/.test(zipCityParts[0]) && /^\d{2}$/.test(zipCityParts[1])) {
      zipCode = zipCityParts[0] + zipCityParts[1];
      city = zipCityParts.slice(2).join(' ');
    }
  }

  if (!/^\d{5}$/.test(zipCode) || !city) {
    throw new Error(`Kunde inte parsa postnummer och stad från: "${zipCityRaw}"`);
  }

  return {
    address: streetRaw,
    zipCode,
    city,
  };
}
